<template>
  <basic-page fluid title="Kalusto">
    <template v-slot:app-bar-buttons>
      <v-btn
        icon
        @click="openQrCodeScanner"
        title="Avaa QR-koodiskanneri"
        color="white"
        ><v-icon>mdi mdi-qrcode-scan</v-icon></v-btn
      >
    </template>
    <v-row class="fill-height kalusto">
      <v-col cols="12" lg="12" offset-xl="2" xl="8">
        <v-tabs v-model="tab">
          <v-tab href="#viikkohuolto"> Viikkohuolto </v-tab>
          <v-tab href="#paineilmalaitehuolto"> Paineilmalaitehuolto </v-tab>
          <v-tab v-if="hasNostoapuvalineetRights" href="#nostoapuvalineet">
            Nostoapuvälineet
          </v-tab>
          <v-tab href="#maaraaikaishuolto"> Määräaikaishuolto </v-tab>
          <v-tab href="#kalusto"> Kalusto </v-tab>
          <v-tab href="#tyypit"> Kaluston tyypit </v-tab>
        </v-tabs>

        <v-row class="mt-2">
          <v-col
            cols="12"
            md="12"
            :class="[
              $vuetify.breakpoint.xsOnly &&
                (tab === 'kalusto' || tab === 'tyypit') &&
                'pa-1',
            ]"
          >
            <v-tabs-items v-model="tab" class="transparent" touchless>
              <v-tab-item name="viikkohuolto" value="viikkohuolto">
                <v-card flat>
                  <v-card-title
                    >Kaluston viikkohuollon tehtävät
                    <v-spacer />
                  </v-card-title>
                  <v-divider />
                  <v-card-text>
                    <v-alert
                      v-if="
                        latestPesuaineValue !== null &&
                        latestPesuaineValue <= 20
                      "
                      type="error"
                      outlined
                      prominent
                      border="left"
                      class="mb-4"
                    >
                      <div class="text-h6">Huomio! Pesuaine vähissä</div>
                      <div>
                        Viimeisin mitattu pesuaineen määrä on
                        <strong>{{ latestPesuaineValue }} cm</strong>. (Raja: 20
                        cm)
                      </div>
                    </v-alert>
                    <ol>
                      <li>Ajoneuvojen siisteyden varmistaminen</li>
                      <li>Kaluston viikkotarkastukset ja koekäytöt</li>
                      <li>Paineilmahuolto Porissa</li>
                      <li>Letkuhuolto Ulvilassa</li>
                      <li>
                        Asema: kalustohallin (lattia) ja pesuhallin (lattia,
                        seinät) pesu, roskikset, pesuaineen mittaus
                      </li>
                      <li>Muut mahdolliset kalustonhuollon tehtävät</li>
                      <li>
                        HUOM. 511 tarkastuksen yhteydessä moottoriruiskun
                        lataukseen laittaminen tarkastuksen alussa ja latauksen
                        lopettaminen lähdettäessä.
                      </li>
                    </ol>
                  </v-card-text>
                  <v-divider />
                  <v-card-title
                    >Kalustonhuollon ryhmät
                    <v-spacer />
                  </v-card-title>
                  <v-divider />
                  <v-card-text class="pt-7">
                    <v-row>
                      <v-col
                        cols="1"
                        lg="1"
                        v-if="$vuetify.breakpoint.lgAndUp"
                      ></v-col>
                      <v-col
                        cols="4"
                        lg="2"
                        v-for="(group, i) in groups"
                        :key="group.number"
                        :class="[
                          filteredWeeksAndGroups[0].group === group.number &&
                            'current-week',
                          'mt-2',
                        ]"
                      >
                        <v-row
                          style="border: 1px solid #ccc"
                          :class="[i % 2 === 0 && 'odd'].join(' ')"
                        >
                          <v-col cols="12">
                            <strong class="text-subtitle-1">{{
                              group.name
                            }}</strong>
                          </v-col>
                        </v-row>
                        <v-row
                          v-for="person in group.people"
                          :key="person.name"
                          :class="[i % 2 === 0 && 'odd'].join(' ')"
                          style="
                            border-right: 1px solid #ccc;
                            border-left: 1px solid #ccc;
                          "
                        >
                          <v-col
                            cols="12"
                            :style="{ borderBottom: '1px solid #ccc' }"
                          >
                            <strong>{{ person.name }}</strong>
                            <br />
                            <span class="caption">{{ person.title }}</span>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-card-text>
                  <v-divider class="mt-5" />
                  <v-card-title
                    >Kalustonhuollon aikataulutus
                    <v-spacer />
                  </v-card-title>
                  <v-divider />
                  <v-card-text class="pt-7">
                    <v-simple-table>
                      <thead>
                        <tr>
                          <th>Viikko</th>
                          <th>Yksikkö</th>
                          <th>Ryhmä</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="wg in filteredWeeksAndGroups" :key="wg.week">
                          <td :class="[wg.current && 'blue lighten-5']">
                            <strong>{{ wg.week }}</strong>
                            <span
                              class="caption ml-md-2 d-block d-md-inline-block"
                              >({{ wg.startDate }} - {{ wg.endDate }})</span
                            >
                          </td>
                          <td :class="[wg.current && 'blue lighten-5']">
                            {{ wg.engine }}
                          </td>
                          <td :class="[wg.current && 'blue lighten-5']">
                            {{ wg.group }}
                          </td>
                        </tr>
                      </tbody>
                    </v-simple-table>
                  </v-card-text>
                  <v-divider />
                  <v-card-title>
                    Tarkastuslomake
                    <v-spacer />
                    <v-btn
                      icon
                      x-small
                      color="transparent"
                      @click="futureWeeksMode = !futureWeeksMode"
                    >
                      <v-icon color="grey lighten-3">mdi-wrench</v-icon>
                    </v-btn>
                  </v-card-title>
                  <v-divider />
                  <v-card-text>
                    <div>
                      <v-btn
                        text
                        block
                        @click="showHistoryTable = !showHistoryTable"
                        class="mb-4"
                      >
                        {{
                          showHistoryTable
                            ? "Piilota historia"
                            : "Näytä historia"
                        }}
                        <v-icon right>{{
                          showHistoryTable
                            ? "mdi-chevron-up"
                            : "mdi-chevron-down"
                        }}</v-icon>
                      </v-btn>
                      <v-expand-transition>
                        <div v-show="showHistoryTable">
                          <h3>Viimeisimmät 10 viikkoa</h3>
                          <pesuaine-chart :history-data="recentHistoryData" />
                          <v-data-table
                            :headers="[
                              { text: 'Viikko', value: 'week' },
                              { text: 'Tarkastukset', value: 'checks' },
                            ]"
                            :items="recentHistoryData"
                            :loading="loadingRecentHistory"
                            hide-default-footer
                            disable-pagination
                            class="elevation-1 mb-5 mt-2"
                          >
                            <template v-slot:item.week="{ item }">
                              <a @click="selectedWeek = item.week">{{
                                item.week
                              }}</a>
                            </template>
                            <template v-slot:item.checks="{ item }">
                              <v-chip
                                v-for="check in item.checks"
                                :key="check.id"
                                small
                                class="mr-1 mb-1"
                                @click="openCheck(item.week, check.engine)"
                                color="green lighten-4"
                              >
                                {{ check.engine }}
                              </v-chip>
                            </template>
                          </v-data-table>

                          <v-expansion-panels flat class="mb-5">
                            <v-expansion-panel>
                              <v-expansion-panel-header
                                >Vanhempi historia</v-expansion-panel-header
                              >
                              <v-expansion-panel-content>
                                <v-select
                                  v-model="selectedWeek"
                                  :items="olderWeeks"
                                  outlined
                                  label="Valitse viikko historiasta"
                                  hide-details
                                >
                                </v-select>
                              </v-expansion-panel-content>
                            </v-expansion-panel>
                          </v-expansion-panels>
                        </div>
                      </v-expand-transition>
                    </div>

                    <v-divider class="my-5" />

                    <v-expand-transition>
                      <div v-if="futureWeeksMode" class="mb-4">
                        <v-select
                          v-model="selectedWeek"
                          :items="futureWeeks"
                          label="Tulevat viikot"
                          outlined
                          hide-details
                        ></v-select>
                      </div>
                    </v-expand-transition>

                    <v-row>
                      <v-col cols="12" md="12">
                        <v-btn
                          block
                          large
                          color="primary"
                          outlined
                          @click="selectCurrentWeek"
                          :disabled="selectedWeek === currentWeekText"
                        >
                          Siirry nykyiseen viikkoon ({{ currentWeekText }})
                        </v-btn>
                      </v-col>
                    </v-row>

                    <v-divider class="my-5" />

                    <div v-if="selectedWeek">
                      <div
                        class="d-flex align-center justify-space-between mb-4"
                      >
                        <h3>Viikko {{ selectedWeek }}</h3>
                        <v-chip
                          v-if="selectedWeek === currentWeekText"
                          color="green lighten-4"
                          >Nykyinen viikko</v-chip
                        >
                        <v-chip v-else>Historia</v-chip>
                      </div>

                      <v-card outlined class="mb-4">
                        <v-progress-linear
                          indeterminate
                          v-if="loadingKalustonhuoltoData"
                        ></v-progress-linear>
                        <v-list two-line>
                          <v-list-item
                            v-for="engine in selectedWeekEngines"
                            :key="engine"
                            @click="selectedEngine = engine"
                            :class="[
                              selectedEngine === engine &&
                                'v-list-item--active',
                            ]"
                            :disabled="loadingKalustonhuoltoData || loadingSave"
                          >
                            <v-list-item-avatar>
                              <v-icon
                                :class="
                                  getEngineEntry(engine)
                                    ? 'green--text'
                                    : 'grey--text'
                                "
                              >
                                {{
                                  getEngineEntry(engine)
                                    ? "mdi-check-circle"
                                    : "mdi-circle-outline"
                                }}
                              </v-icon>
                            </v-list-item-avatar>
                            <v-list-item-content>
                              <v-list-item-title>{{
                                engine
                              }}</v-list-item-title>
                              <v-list-item-subtitle
                                v-if="getEngineEntry(engine)"
                              >
                                {{
                                  $formatDateAndHourMinute(
                                    getEngineEntry(engine).createdAt,
                                  )
                                }}
                                <span v-if="getEngineEntry(engine).createdBy">
                                  -
                                  {{ getEngineEntry(engine).createdBy.user }}
                                </span>
                              </v-list-item-subtitle>
                              <v-list-item-subtitle
                                v-else-if="!loadingKalustonhuoltoData"
                              >
                                Ei tarkastettu
                              </v-list-item-subtitle>
                            </v-list-item-content>
                            <v-list-item-action>
                              <v-icon>mdi-chevron-right</v-icon>
                            </v-list-item-action>
                          </v-list-item>
                        </v-list>
                      </v-card>
                    </div>
                  </v-card-text>
                  <v-card-text v-if="selectedEngine && selectedWeek">
                    <v-row
                      v-for="engine in [selectedEngine]"
                      :key="engine"
                      class="mb-10"
                    >
                      <v-col cols="12">
                        <h3>{{ engine }}</h3>
                        <div v-if="partsForm && partsForm.createdAt">
                          Luotu:
                          {{ $formatDateAndHourMinute(partsForm.createdAt) }} -
                          <span v-if="partsForm.createdBy">{{
                            partsForm.createdBy.user
                          }}</span>
                        </div>
                        <div v-if="partsForm && partsForm.updatedAt">
                          Päivitetty:
                          {{ $formatDateAndHourMinute(partsForm.updatedAt) }} -
                          <span v-if="partsForm.updatedBy">{{
                            partsForm.updatedBy.user
                          }}</span>
                        </div>
                        <div
                          v-if="
                            partsForm &&
                            partsForm.editors &&
                            partsForm.editors.length > 0
                          "
                        >
                          Muokkaajat:
                          {{ partsForm.editors.map((e) => e.user).join(", ") }}
                        </div>
                        <v-divider />
                      </v-col>

                      <v-col cols="12" v-if="partsForm">
                        <template v-for="(ep, i) in partsForm.form">
                          <v-row :key="i">
                            <template v-if="ep.type === 'title'">
                              <v-col
                                cols="12"
                                class="align-center justify-space-between mt-5 mb-5 border-bottom"
                              >
                                <span
                                  class="text-subtitle-1 font-weight-bold"
                                  >{{ ep.title }}</span
                                >
                              </v-col>
                            </template>
                            <template v-else-if="ep.type === 'measurement'">
                              <v-col
                                cols="12"
                                :class="[
                                  'd-flex align-center justify-space-between py-1 border-bottom',
                                  ep.value || ep.value === 0 || ep.value === '0'
                                    ? 'green lighten-5'
                                    : 'red lighten-5',
                                ]"
                              >
                                <v-text-field
                                  :value="ep.value"
                                  @input="updateMeasurement(i, $event)"
                                  :label="ep.title"
                                  type="number"
                                  outlined
                                  dense
                                  hide-details
                                  class="my-2"
                                  background-color="white"
                                ></v-text-field>
                              </v-col>
                            </template>
                            <template v-else>
                              <v-col
                                cols="9"
                                :class="[
                                  'd-flex align-center justify-space-between py-1',
                                  ep.done === 2 &&
                                    'green lighten-5 green--text',
                                  ep.done === 1 &&
                                    'orange lighten-5 orange--text',
                                  ep.done === 0 && 'red lighten-5 red--text',
                                  'border-bottom',
                                ]"
                              >
                                <span class="text-subtitle-2">
                                  {{ ep.title }}
                                  <v-icon
                                    v-if="ep.done === 2"
                                    class="green lighten-5 green--text"
                                    >mdi mdi-check</v-icon
                                  >
                                  <v-icon
                                    v-if="ep.done === 1"
                                    class="orange lighten-5 orange--text"
                                    >mdi mdi-exclamation-thick</v-icon
                                  >
                                  <v-icon
                                    v-if="ep.done === 0"
                                    class="red lighten-5 red--text"
                                    >mdi mdi-alert</v-icon
                                  >
                                </span>

                                <span class="caption" v-if="ep.description">{{
                                  ep.description
                                }}</span>
                              </v-col>
                              <v-col
                                cols="3"
                                :class="[
                                  'd-flex align-center py-1',
                                  ep.done === 2 &&
                                    'green lighten-5 green--text',
                                  ep.done === 1 &&
                                    'orange lighten-5 orange--text',
                                  ep.done === 0 && 'red lighten-5 red--text',
                                  'border-bottom',
                                  'justify-end',
                                ]"
                              >
                                <v-btn
                                  icon
                                  @click="updateStatus(i, 2)"
                                  v-if="!ep.done && ep.done !== 0"
                                >
                                  <v-icon>mdi mdi-check</v-icon>
                                </v-btn>
                                <v-btn
                                  icon
                                  @click="updateStatus(i, 1)"
                                  v-if="ep.done === 2"
                                >
                                  <v-icon>mdi mdi-check</v-icon>
                                </v-btn>
                                <v-btn
                                  icon
                                  @click="updateStatus(i, 0)"
                                  v-if="ep.done === 1"
                                >
                                  <v-icon>mdi mdi-check</v-icon>
                                </v-btn>
                                <v-btn
                                  icon
                                  @click="updateStatus(i, null)"
                                  v-if="ep.done === 0"
                                >
                                  <v-icon>mdi mdi-close</v-icon>
                                </v-btn>
                              </v-col>
                            </template>
                          </v-row>
                          <!--<v-divider :key="`divider_${i}`" />-->
                        </template>
                        <v-row>
                          <v-col cols="12">
                            <v-textarea
                              outlined
                              auto-grow
                              label="Huomiot"
                              :value="partsForm.notices"
                              @input="updateNotices"
                            />
                          </v-col>
                          <v-col cols="12">
                            <v-textarea
                              outlined
                              auto-grow
                              label="Jälkikommentit (Päällikkön täytettävä)"
                              :value="partsForm.postInspectionComment"
                              @input="updatePostInspectionComment"
                              :disabled="
                                !(
                                  $userInfo &&
                                  $userInfo.email === 'jarnojjoensuu@gmail.com'
                                )
                              "
                            />
                          </v-col>
                          <v-col cols="12" class="mt-n5">
                            <file-upload
                              ref="fileupload"
                              accepted-file-types="image/*"
                              label="Paina tästä lisätäksesi kuvia"
                            />
                          </v-col>
                          <v-col cols="12">
                            <v-row>
                              <v-col
                                cols="12"
                                md="6"
                                v-for="(image, index) in partsForm.files"
                                :key="`${image.filename}_${index}`"
                              >
                                <v-btn
                                  icon
                                  color="white"
                                  outlined
                                  small
                                  :disabled="loadingSave"
                                  class="image-delete-btn"
                                  elevation="2"
                                  @click.stop="deleteFile(index, image)"
                                  ><v-icon>mdi mdi-close</v-icon></v-btn
                                >
                                <v-img
                                  @click="downloadBase64File(image)"
                                  lazy
                                  :src="image.content"
                                  :alt="image.filename"
                                  width="100%"
                                  height="100%"
                                  :data-deleted="image._deleted"
                                  :class="[image._deleted && 'deleted-image']"
                                ></v-img>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                        <v-row class="mt-6">
                          <v-col cols="12">
                            <v-btn
                              block
                              color="primary"
                              @click="saveForm"
                              :loading="loadingSave"
                              >Tallenna {{ engine }}</v-btn
                            >
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-card-text>

                  <v-card-text v-else>
                    <v-divider />
                    <v-row class="mt-2">
                      <v-col cols="12">
                        <v-alert type="info" outlined>
                          Valitse viikko ja yksikkö
                        </v-alert>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <v-tab-item
                name="paineilmalaitehuolto"
                value="paineilmalaitehuolto"
              >
                <paineilmalaitehuolto-view />
              </v-tab-item>
              <v-tab-item name="nostoapuvalineet" value="nostoapuvalineet">
                <nostoapuvalineethuolto-view />
              </v-tab-item>
              <v-tab-item name="maaraaikaishuolto" value="maaraaikaishuolto">
                <maaraaikaishuolto-view flat />
              </v-tab-item>
              <v-tab-item name="kalusto" value="kalusto">
                <kalusto-view ref="kalustoView" />
              </v-tab-item>
              <v-tab-item name="tyypit" value="tyypit">
                <kalusto-tyypit-view @update="updateTypes" />
              </v-tab-item>
            </v-tabs-items>
            <br class="mb-10" />
            <br class="mb-10" />
            <br class="mb-10" />
            <br class="mb-10" />
            <br class="mb-10" />
          </v-col>
        </v-row>
      </v-col>
      <qr-code-scanner-dialog @detect="onDetect" v-model="showQrCodeScanner" />
    </v-row>
  </basic-page>
</template>

<script>
import BasicPage from "@/components/BasicPage";
import dayjs from "dayjs";
import {
  computeWeeksAndGroups,
  KALUSTOHUOLTO_GROUPS,
} from "../../functions/kalustohuoltoSchedule";
import api from "@/api";
import RefreshButton from "@/components/RefreshButton.vue";
import FileUpload from "@/components/FileUpload.vue";
import MaaraaikaishuoltoView from "@/views/MaaraaikaishuoltoView.vue";
import KalustoTyypitView from "@/views/KalustoTyypitView.vue";
import KalustoView from "@/views/KalustoView.vue";
import PaineilmalaiteHuoltoDialog from "@/components/PaineilmalaiteHuoltoDialog.vue";
import PaineilmalaitehuoltoView from "@/views/PaineilmalaitehuoltoView.vue";
import NostoapuvalineethuoltoView from "@/views/NostoapuvalineethuoltoView.vue";
import {
  collection,
  doc,
  getDoc,
  getDocs,
  query,
  where,
  onSnapshot,
  updateDoc,
  setDoc,
  arrayUnion,
  runTransaction,
} from "firebase/firestore";
import { firestore as db } from "@/plugins/firebase.app";
import { orderBy, debounce } from "lodash";
import QrCodeScannerDialog from "@/views/QrCodeScannerDialog.vue";
import PesuaineChart from "@/components/PesuaineChart.vue";

let isoWeek = require("dayjs/plugin/isoWeek");
let advancedFormat = require("dayjs/plugin/advancedFormat");
dayjs.extend(isoWeek);
dayjs.extend(advancedFormat);

export default {
  name: "Kalustonhuolto",
  components: {
    PesuaineChart,
    QrCodeScannerDialog,
    PaineilmalaitehuoltoView,
    NostoapuvalineethuoltoView,
    KalustoView,
    KalustoTyypitView,
    MaaraaikaishuoltoView,
    FileUpload,
    BasicPage,
  },
  data: () => {
    return {
      loading: false,
      users: [],
      editModal: false,
      user: null,
      kalustonhuoltoData: null,
      loadingKalustonhuoltoData: false,
      loadingSave: false,
      loadingPaineilmalaiteHuoltoData: false,
      showQrCodeScanner: false,
      loadingRecentHistory: false,
      recentHistoryData: [],
      showHistoryTable: false,
      preventClearEngine: false,
      unsubscribeSnapshot: null,
      pendingUpdates: {},
      futureWeeksMode: false,
      //simulatedNow: "2026-01-06",

      tab: 0,
      groups: KALUSTOHUOLTO_GROUPS,
      selectedWeek: null,
      selectedEngine: null,
      showHistoryWeeks: false,
      partsForm: null,
      checkParts: [
        {
          title: "Kalustohallin lattian pesu",
          engines: ["Asema"],
        },
        {
          title: "Pesuhallin lattian ja seinien pesu",
          engines: ["Asema"],
        },
        {
          title: "Pesuhallin roskisten likaisten letkujen vaihto Ulvilassa",
          engines: ["Asema"],
        },

        {
          title: "Roskikset (pesuhallin roskisten tyhjennys ja pesu)",
          engines: ["Asema"],
        },
        {
          id: "pesuaine_mittaus",
          title: "Pesuhallin pesuaineen mittaus (senttimetriä cm)",
          engines: ["511", "5112", "5188", "Asema"],
          type: "measurement",
        },
        {
          title: "Yksikkö",
          type: "title",
          engines: [
            "511",
            "5112",
            "513",
            "517",
            "Pumppuperävaunu",
            "518",
            "5188",
          ],
        },
        {
          title: "Moottori- ja ohjaustehostinöljy",
          engines: ["511", "5112", "513", "517", "Pumppuperävaunu", "5188"],
        },
        {
          title: "Jäähdytysneste",
          engines: ["511", "5112", "513", "517", "5188"],
        },
        {
          title: "Lasinpesujärjestelmä",
          engines: ["511", "5112", "513", "517"],
        },
        {
          title: "Valot",
          engines: [
            "511",
            "5112",
            "513",
            "517",
            "Pumppuperävaunu",
            "518",
            "5188",
          ],
        },
        {
          title: "Hälytinlaitteet ja radiokalusto",
          engines: ["511", "5112", "513", "517"],
        },
        { title: "Jarru- ja kytkinneste", engines: ["517"] },
        {
          title: "Akkuvesi",
          engines: [
            "511",
            "5112",
            "513",
            "517",
            "Pumppuperävaunu",
            "518",
            "5188",
          ],
        },
        {
          title: "Renkaiden kunto ja rengaspaineet akseleilla",
          engines: [
            { engine: "511", description: "8,0/8,0" },
            { engine: "5112", description: "8,0/8,0" },
            { engine: "513", description: "8,0/8,0/8,0/8,0" },
            { engine: "517", description: "Ohjekirja" },
            { engine: "Pumppuperävaunu", description: "2,2/2,2" },
            { engine: "5188", description: "0,6/0,6" },
          ],
        },
        {
          title: "Polttoainemäärä / AD-Blue",
          engines: [
            { engine: "511", description: "AD-Blue" },
            "5112",
            "513",
            { engine: "517", description: "AD-Blue" },
            "Pumppuperävaunu",
            "518",
            "5188",
          ],
        },
        {
          title:
            'Palopumpun toiminta ja säiliöveden määrä. Runsas veden käyttö 9 barin paineella ja sen jälkeen säiliön täyttö HITAASTI 1,5" työjohtoa käyttäen pesuhallista',
          engines: ["511", "5112", "513"],
        },
        {
          title: "Generaattorin toiminta",
          engines: ["511", "5112"],
        },
        {
          title: "Vinssin toiminta",
          engines: ["511", "5112"],
        },
        {
          title: "Korirakenteet, kolhut, naarmut yms.",
          engines: ["511", "5112", "513", "Pumppuperävaunu"],
        },
        {
          title: "Puhtaus ja siisteys",
          engines: [
            "511",
            "5112",
            "513",
            "517",
            "Pumppuperävaunu",
            "518",
            "5188",
          ],
        },
        {
          title: "Irtokalusto",
          type: "title",
          engines: [
            "511",
            "5112",
            "513",
            "517",
            "Pumppuperävaunu",
            "518",
            "5188",
          ],
        },
        {
          title: "Valaisinkalusto, käsivalaisimet akkujen tyhjennys ja lataus",
          engines: ["511", "5112", "513", "Pumppuperävaunu"],
        },
        {
          title: "Moottoriruisku + akun lataaminen + 1 min koekäyttö kuivana",
          engines: ["511"],
        },
        {
          title: "Letkukalusto, oikea määrä ja koko",
          engines: ["511", "5112", "513", "Pumppuperävaunu", "5188"],
        },
        {
          title: "Uppopumput / nokipalosarja",
          engines: ["511"],
        },
        {
          title: "Armatuuri- ja suihkuputkikalusto",
          engines: ["511", "5112", "513", "Pumppuperävaunu", "5188"],
        },
        {
          title: "Mittarit",
          engines: ["511"],
        },
        {
          title: "Käsisammuttimet",
          engines: ["511", "5112", "513", "517", "518", "5188"],
        },
        {
          title: "Vaahtokalusto / vedenpehmennin",
          engines: ["511", "5112", "513"],
        },
        {
          title: "Pelastusvälinesarja",
          engines: ["511", "5112"],
        },
        {
          title: "Nostotyynykalusto",
          engines: ["511", "5112"],
        },
        {
          title: "Nosto- ja vetoliinat, sakkelit ja pylpyrä",
          engines: ["511", "5112", "513"],
        },
        {
          title: "Käsityökalut",
          engines: ["511", "5112", "513", "Pumppuperävaunu", "518", "5188"],
        },
        {
          title: "Moottorisahat ja laikkaleikkuri (väh. 2 min koekäyttö)",
          engines: ["511", "5112", "513"],
        },
        {
          title: "Sähkö- ja akkukäyttöinen kalusto / akkujen lataus",
          engines: ["511", "5112"],
        },
        {
          title: "Savutuuletinkalusto",
          engines: ["511", "5112"],
        },
        {
          title: "Moottoriruisku (1 min koekäyttö kuivana)",
          engines: ["5112", "Pumppuperävaunu"],
        },
        {
          title: "Imeytysaineet",
          engines: ["511", "5112"],
        },
        {
          title: "Korkealla työskentelyn kalusto, pelastus+katto",
          engines: ["511", "5112"],
        },
        {
          title: "Kemikaalisuojapukukalusto (kassit ovat sinetöityjä)",
          engines: ["511"],
        },
        {
          title: "Vesipelastuskalusto",
          engines: ["511", "5112"],
        },
        {
          title: "Ensivastekalusto",
          engines: ["511", "5112", "517"],
        },
        {
          title: "Tikaskalusto",
          engines: ["511", "5112"],
        },
        {
          title:
            "Paineilmalaitteet, lämpökamera, tietokone/PEKEn käynnistäminen",
          engines: ["511", "5112"],
        },
        {
          title: "511 putkilukon avaimen päivitys Kanta-Porissa 4kk välein",
          engines: ["511"],
        },
        {
          title: "Hälytysmuonat ja -juomat",
          engines: ["511", "5112", "513"],
        },
        {
          title: "Muu irtokalusto",
          engines: [
            "511",
            "5112",
            "513",
            "517",
            "Pumppuperävaunu",
            "518",
            "5188",
          ],
        },
      ],
    };
  },
  watch: {
    tab() {
      if (this.$route?.query?.tab !== this.tab)
        this.$router.push({ query: { tab: this.tab } });
    },
    "$route.query.tab": {
      immediate: true,
      handler(newTab) {
        // Convert query parameter to number if your tab index is numeric
        this.tab = newTab ? newTab : "viikkohuolto";
      },
    },
    selectableWeeks(val) {
      if (val?.findIndex((w) => w.week === this.selectedWeek) > -1) return;
      this.selectedWeek = null;
    },
    selectedWeek(val) {
      if (!this.preventClearEngine) {
        this.selectedEngine = null;
      }
      if (!val) this.kalustonhuoltoData = null;
      else this.getKalustonhuoltoByWeek(val);
    },
    kalustonhuoltoData() {
      this.updatePartsForm();
    },
    selectedEngine() {
      this.updatePartsForm();
    },
  },
  computed: {
    hasNostoapuvalineetRights() {
      return (
        this.$userInfo?.email === "valtteri.kankaristo@hotmail.com" ||
        this.$isSuperAdmin
      );
    },
    weeks() {
      return this.weeksAndGroups.map((wg) => wg.week);
    },
    allWeeksInHistory() {
      const start = dayjs("2023-06-05");
      const end = dayjs(this.simulatedNow || undefined);
      const weeks = end.diff(start, "week") + 1;
      return Array.from({ length: weeks }, (_, i) =>
        start.add(i, "week").format("WW/GGGG"),
      );
    },
    currentWeekText() {
      let now = dayjs(this.simulatedNow || undefined);
      if (now.isBefore(dayjs("2023-06-05"))) {
        now = dayjs("2023-06-05");
      }
      return now.format("WW/GGGG");
    },
    last10Weeks() {
      return this.allWeeksInHistory.slice(-10).reverse();
    },
    olderWeeks() {
      const last10 = this.last10Weeks;
      return [...this.allWeeksInHistory]
        .reverse()
        .filter((w) => !last10.includes(w));
    },
    historyWeeks() {
      return [...this.allWeeksInHistory]
        .reverse()
        .filter((w) => w !== this.currentWeekText);
    },
    selectableWeeks() {
      let now = dayjs(this.simulatedNow || undefined);
      if (now.isBefore(dayjs("2023-06-05"))) {
        now = dayjs("2023-06-05");
      }
      if (this.showHistoryWeeks) {
        return [...this.allWeeksInHistory].reverse();
      }
      return [now.format("WW/GGGG")];
    },
    filteredWeeksAndGroups() {
      const now = dayjs(this.simulatedNow || undefined).format("GGGGWW");
      return this.weeksAndGroups.filter((wg) => wg.weekNumber >= now);
    },
    futureWeeks() {
      const start = dayjs(this.simulatedNow || undefined).add(1, "week");
      return Array.from({ length: 5 }, (_, i) =>
        start.add(i, "week").format("WW/GGGG"),
      );
    },
    weeksAndGroups() {
      return computeWeeksAndGroups({ simulatedNow: this.simulatedNow });
    },
    selectedWeekEngines() {
      return this.parseEngines(
        this.weeksAndGroups.find((w) => w.week === this.selectedWeek),
      );
    },
    selectedEngineParts() {
      if (!this.selectedEngine) return [];
      return this.getPartsForEngine(
        this.weeksAndGroups.find((w) => w.week === this.selectedWeek),
        this.selectedEngine,
      );
    },
    filteredPaineilmalaiteHuoltoData() {
      return orderBy(
        this.paineilmalaiteHuoltoData.map((p) => {
          if (p.form?.some((f) => f.type === null && f.done === 0)) {
            p._color = "error";
          } else if (p.form?.some((f) => f.type === null && f.done === 1)) {
            p._color = "warning";
          } else {
            p._color = "success";
          }
          p.pressure = p.form?.find(
            (f) => f.type === "pressure_select",
          )?.pressure;
          return p;
        }),
        ["date", "createdAt"],
        ["desc", "desc"],
      );
    },
    latestPesuaineValue() {
      // recentHistoryData is sorted by week (oldest to newest based on how it's constructed in getRecentHistory)
      // Wait, getRecentHistory maps over last10Weeks.
      // last10Weeks = allWeeksInHistory.slice(-10).reverse(); -> Newest first.
      // So recentHistoryData[0] is the newest week.

      for (const weekData of this.recentHistoryData) {
        for (const check of weekData.checks) {
          if (check.form && Array.isArray(check.form)) {
            const measurementItem = check.form.find(
              (item) =>
                item.id === "pesuaine_mittaus" ||
                item.title === "Pesuaineen mittaus" ||
                item.title === "Pesuhallin pesuaineen mittaus",
            );
            if (measurementItem && measurementItem.value) {
              const parsed = parseFloat(measurementItem.value);
              if (!isNaN(parsed)) {
                return parsed;
              }
            }
          }
        }
      }
      return null;
    },
  },
  methods: {
    editPaineilmalaiteHuolto(data) {
      this.$refs.paineilmalaiteHuoltoDialog?.open(data);
    },
    updatePartsForm() {
      if (!this.selectedEngine) {
        this.partsForm = null;
        return;
      }
      const enginePartsForm = this.kalustonhuoltoData?.find(
        (k) => k.engine === this.selectedEngine && k.week === this.selectedWeek,
      );
      if (enginePartsForm) {
        if (this.partsForm && this.partsForm.id === enginePartsForm.id) {
          // Merge updates to avoid overwriting local state completely
          this.partsForm.updatedAt = enginePartsForm.updatedAt;
          this.partsForm.updatedBy = enginePartsForm.updatedBy;
          this.partsForm.editors = enginePartsForm.editors;
          this.partsForm.files = enginePartsForm.files; // Files are usually not edited in text fields

          if (this.partsForm.notices !== enginePartsForm.notices) {
            this.partsForm.notices = enginePartsForm.notices;
          }
          if (
            this.partsForm.postInspectionComment !==
            enginePartsForm.postInspectionComment
          ) {
            this.partsForm.postInspectionComment =
              enginePartsForm.postInspectionComment;
          }

          if (enginePartsForm.form && this.partsForm.form) {
            enginePartsForm.form.forEach((newItem, index) => {
              const oldItem = this.partsForm.form[index];
              if (oldItem) {
                // Update status
                if (oldItem.done !== newItem.done) {
                  oldItem.done = newItem.done;
                }
                // Update value only if not currently focused to avoid overwriting user input
                // We can't easily check focus here, but we can check if values differ
                if (oldItem.value !== newItem.value) {
                  // If the user is typing, local value might be newer.
                  // But we don't know.
                  // For now, let's update it. If it causes issues with typing, we need a more complex solution.
                  // A simple heuristic: if the difference is just one char, maybe don't update?
                  // But "real-time sync" implies we want to see others' changes.
                  // Let's trust the server for now, but maybe we can check document.activeElement later if needed.
                  oldItem.value = newItem.value;
                }
              }
            });
          }
        } else {
          this.partsForm = { ...enginePartsForm, lastModified: Date.now() };
        }
      } else {
        // eslint-disable-next-line no-undef
        this.partsForm = structuredClone({
          week: this.selectedWeek,
          engine: this.selectedEngine,
          form: this.selectedEngineParts,
          notices: "",
          postInspectionComment: "",
          lastModified: Date.now(),
          groupNumber: this.weeksAndGroups.find(
            (wg) => wg.week === this.selectedWeek,
          )?.group,
        });
      }
    },
    selectCurrentWeek() {
      this.selectedWeek = this.currentWeekText;
    },
    openCheck(week, engine) {
      this.preventClearEngine = true;
      this.selectedWeek = week;
      this.selectedEngine = engine;
      this.$nextTick(() => {
        this.preventClearEngine = false;
      });
    },
    getEngineEntry(engine) {
      return this.kalustonhuoltoData?.find((d) => d.engine === engine);
    },
    async getRecentHistory() {
      this.loadingRecentHistory = true;
      try {
        const weeks = this.last10Weeks;
        if (weeks.length === 0) return;

        const q = query(
          collection(db, "kalustonhuolto"),
          where("week", "in", weeks),
        );
        const snapshot = await getDocs(q);
        const data = snapshot.docs.map((doc) => ({
          ...doc.data(),
          id: doc.id,
        }));

        this.recentHistoryData = weeks.map((week) => {
          const checks = data.filter((d) => d.week === week);
          return {
            week,
            checks,
          };
        });
      } catch (e) {
        console.error(e);
      }
      this.loadingRecentHistory = false;
    },
    openPaineilmalaiteHuoltoDialog() {
      this.$refs.paineilmalaiteHuoltoDialog?.open();
    },
    async getPaineilmalaiteHuoltoData() {
      this.loadingPaineilmalaiteHuoltoData = true;
      try {
        const snapshot = await getDocs(
          query(
            collection(db, "paineilmalaitehuolto"),
            where("deleted", "==", false),
          ),
        );
        this.paineilmalaiteHuoltoData = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
      } catch (e) {
        console.error(e);
        this.$toast("Virhe haettaessa paineilmalaitehuolto data", {
          type: "error",
          timeout: 3000,
        });
      }
      this.loadingPaineilmalaiteHuoltoData = false;
    },
    async updateTypes() {
      try {
        this.$refs.kalustoView?.fetchEquipmentTypes?.();
      } catch (e) {
        console.error(e);
      }
    },
    async getKalustonhuoltoByWeek() {
      this.loadingKalustonhuoltoData = true;
      if (this.unsubscribeSnapshot) {
        this.unsubscribeSnapshot();
        this.unsubscribeSnapshot = null;
      }

      try {
        const q = query(
          collection(db, "kalustonhuolto"),
          where("week", "==", this.selectedWeek),
        );

        this.unsubscribeSnapshot = onSnapshot(
          q,
          (snapshot) => {
            this.kalustonhuoltoData = snapshot.docs.map((doc) => {
              const data = doc.data();
              if (data.files) {
                data.files.forEach((f) => {
                  f._deleted = false;
                });
              }
              return {
                id: doc.id,
                ...data,
              };
            });
            this.loadingKalustonhuoltoData = false;
          },
          (error) => {
            console.error("Error fetching kalustonhuolto data:", error);
            this.loadingKalustonhuoltoData = false;
          },
        );
      } catch (e) {
        console.error(e);
        this.loadingKalustonhuoltoData = false;
      }
    },
    parseEngines(weekAndGroup) {
      if (weekAndGroup?.engine) {
        return weekAndGroup.engine.split(",").map((e) => e.trim());
      }
      return [];
    },
    parseParts(weekAndGroup) {
      const engines = this.parseEngines(weekAndGroup);
      return this.checkParts.filter((p) => {
        return engines.some((e) => {
          return p.engines.some((pe) =>
            typeof pe === "string" ? pe === e : pe.engine === e,
          );
        });
      });
    },
    getPartsForEngine(weekAndGroup, engine) {
      const parts = this.parseParts(weekAndGroup);
      return parts
        .filter((p) => {
          return p.engines.some((pe) => {
            return typeof pe === "string"
              ? pe === engine
              : pe.engine === engine;
          });
        })
        .map((p) => {
          return {
            id: p.id || null,
            title: p.title,
            description:
              p.engines.find(
                (pe) => typeof pe === "object" && pe.engine === engine,
              )?.description || null,
            type: p.type || null,
            done: false,
            value: "",
          };
        });
    },
    async reloadAll() {
      await this.getPaineilmalaiteHuoltoData();
    },
    updateStatus(index, status) {
      this.partsForm.form[index].done = status;
      this.queueUpdate(index, "done", status);
    },
    updateMeasurement(index, value) {
      this.partsForm.form[index].value = value;
      this.queueUpdate(index, "value", value);
    },
    queueUpdate(index, key, value) {
      if (!this.pendingUpdates[index]) {
        this.pendingUpdates[index] = {};
      }
      this.pendingUpdates[index][key] = value;
      this.debouncedFlushUpdates();
    },
    debouncedFlushUpdates: debounce(function () {
      this.flushUpdates();
    }, 1000),
    async flushUpdates() {
      const updatesToProcess = { ...this.pendingUpdates };
      this.pendingUpdates = {};

      if (Object.keys(updatesToProcess).length === 0) return;

      try {
        const userInfo = {
          user: this.$userInfo.displayName || this.$userInfo.email,
          email: this.$userInfo.email,
        };

        let docId = this.partsForm.id;
        if (!docId) {
          // If doc doesn't exist, we must do a full save to create it
          await this.saveForm({ quiet: true });
          return;
        }

        const docRef = doc(db, "kalustonhuolto", docId);

        await runTransaction(db, async (transaction) => {
          const sfDoc = await transaction.get(docRef);
          if (!sfDoc.exists()) {
            throw "Document does not exist!";
          }

          const data = sfDoc.data();
          const form = data.form;

          if (!form) {
            throw "Form data invalid";
          }

          // Apply all pending updates
          for (const [indexStr, fields] of Object.entries(updatesToProcess)) {
            const index = parseInt(indexStr);
            if (form[index]) {
              for (const [key, value] of Object.entries(fields)) {
                form[index][key] = value;
              }
            }
          }

          transaction.update(docRef, {
            form: form,
            updatedAt: Date.now(),
            updatedBy: userInfo,
            editors: arrayUnion(userInfo),
          });
        });
      } catch (e) {
        console.error("Flush updates failed", e);
        // Fallback to full save if update fails
        this.saveForm({ quiet: true });
      }
    },
    updateNotices(value) {
      this.partsForm.notices = value;
      this.debouncedSaveTopLevelField("notices", value);
    },
    updatePostInspectionComment(value) {
      this.partsForm.postInspectionComment = value;
      this.debouncedSaveTopLevelField("postInspectionComment", value);
    },
    debouncedSaveTopLevelField: debounce(function (key, value) {
      this.saveTopLevelField(key, value);
    }, 1000),
    async saveTopLevelField(key, value) {
      try {
        const userInfo = {
          user: this.$userInfo.displayName || this.$userInfo.email,
          email: this.$userInfo.email,
        };

        let docId = this.partsForm.id;
        if (!docId) {
          await this.saveForm({ quiet: true });
          return;
        }

        const docRef = doc(db, "kalustonhuolto", docId);
        await updateDoc(docRef, {
          [key]: value,
          updatedAt: Date.now(),
          updatedBy: userInfo,
          editors: arrayUnion(userInfo),
        });
      } catch (e) {
        console.error("Top level field save failed", e);
        this.saveForm({ quiet: true });
      }
    },
    async saveForm(options = {}) {
      const { quiet = false } = options;
      if (!quiet) this.loadingSave = true;
      try {
        const files = await this.$refs.fileupload?.[0]?.getFiles();
        const partsForm = JSON.parse(
          JSON.stringify({
            ...this.partsForm,
            files: [
              ...(this.partsForm?.files?.filter((f) => !f._deleted) || []),
              ...(files || []),
            ],
          }),
        );

        const userInfo = {
          user: this.$userInfo.displayName || this.$userInfo.email,
          email: this.$userInfo.email,
        };

        let docId = partsForm.id;
        if (!docId) {
          const [weekNum, year] = partsForm.week.split("/");
          if (weekNum && year) {
            docId = `${year}-${weekNum}-${partsForm.engine}`;
          } else {
            const newRef = doc(collection(db, "kalustonhuolto"));
            docId = newRef.id;
          }
        }

        const docRef = doc(db, "kalustonhuolto", docId);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          await updateDoc(docRef, {
            ...partsForm,
            id: docId,
            updatedAt: Date.now(),
            updatedBy: userInfo,
            editors: arrayUnion(userInfo),
          });
        } else {
          partsForm.id = docId;
          partsForm.createdAt = Date.now();
          partsForm.createdBy = userInfo;
          partsForm.editors = [userInfo];
          await setDoc(docRef, partsForm);
          // Update local ID so subsequent field saves know the doc exists
          if (this.partsForm) {
            this.partsForm.id = docId;
          }
        }

        if (!quiet) {
          this.$toast("Tallennettu", {
            type: "success",
            timeout: 3000,
          });
        }
        this.$refs.fileupload?.[0]?.reset();
        // No need to reload, onSnapshot handles it
        this.getRecentHistory();
      } catch (e) {
        console.error(e);
        if (!quiet) {
          this.$toast("Tallennus epäonnistui " + e, {
            type: "error",
            timeout: 3000,
          });
        }
      }
      if (!quiet) this.loadingSave = false;
    },
    downloadBase64File(image) {
      const linkSource = image.content;
      const downloadLink = document.createElement("a");
      downloadLink.href = linkSource;
      downloadLink.download = image.filename;
      downloadLink.click();
    },
    deleteFile(index, file) {
      this.partsForm.files[index]._deleted =
        !this.partsForm.files[index]._deleted;
    },
    /*openQrCodeScanner() {
      if (this.$refs?.kalustoView?.openQrCodeScanner) {
        this.$refs.kalustoView.openQrCodeScanner();
      }
    },*/
    openQrCodeScanner() {
      this.showQrCodeScanner = true;
    },
    async onDetect(code) {
      try {
        const snapshot = await getDoc(doc(db, "kalusto", code));
        if (snapshot.exists()) {
          this.showQrCodeScanner = false;
          await this.$router.push({
            name: "KalustoById",
            params: { id: code },
            query: { fromQr: true },
          });
        } else {
          this.$toast("Kalustoa ei löytynyt annetulla ID-koodilla " + code, {
            type: "error",
          });
        }
      } catch (e) {
        console.error(e);
        this.$toast("Virhe haettaessa kalustoa", { type: "error" });
      }
    },
  },
  beforeDestroy() {
    if (this.unsubscribeSnapshot) {
      this.unsubscribeSnapshot();
    }
  },
  mounted() {
    this.reloadAll();
    this.getRecentHistory();
    if (!this.selectedWeek) {
      this.selectedWeek = this.selectableWeeks[0];
    }
  },
};
</script>

<style lang="scss" scoped>
.current-talonhenkilo-row {
  td {
    background: rgba(30, 136, 229, 0.25);
  }
}
.odd {
  background: #eeeeee;
}
.current-week {
  & .row > .col {
    background: #e3f2fd;
    color: #0d47a1;
  }
}
::v-deep .theme--dark,
:host-context(.theme--dark) {
  .current-talonhenkilo-row td {
    background: rgba(30, 136, 229, 0.28) !important;
    color: #ffffff !important;
  }
  .odd {
    background: rgba(255, 255, 255, 0.04) !important;
  }
  .current-week {
    & .row {
      border-color: rgba(66, 165, 245, 0.4) !important;
    }
    & .row > .col {
      background: rgba(30, 136, 229, 0.3) !important;
      color: #ffffff !important;
    }
    strong,
    span {
      color: #ffffff !important;
    }
  }
}
.container .border-bottom {
  border-color: #ccc !important;
  border-bottom: 1px solid #ccc !important;
}
.image-delete-btn {
  position: relative;
  left: 90%;
  z-index: 2;
  top: 40px;
  background-color: #242424;
}
.deleted-image {
  border: 3px solid red !important;
}
</style>
<style lang="scss">
.kalusto .v-slide-group__prev.v-slide-group__prev--disabled {
  display: none !important;
}
</style>
